<template lang="pug">
div.form-empresa
  b-row
    b-col
      b-form-group( label-for="input-razon_social" )
        template( #label ) Razón Social
        b-form-input(
          id="input-razon_social"
          v-model="$v.form.razon_social.$model"
          :state="validateState('razon_social')"
          :disabled="disabled"
        )
        b-form-invalid-feedback Campo requerido

  b-row
    b-col
      b-form-group( label-for="input-correos-empresa" )
        template( #label ) Correos Electrónicos
        b-form-tags(
          input-id="input-correos-empresa"
          v-model="form.correos_empresa"
          placeholder="Agregar correos separados por espacio..."
          invalid-tag-text="Dirección de correo inválida: "
          separator=" "
          tag-variant="primary"
          :tag-validator="validateEmail"
          :disabled="disabled"
        )
        template( #invalid-feedback ) Debe ingresar al menos una dirección de correo
  b-row
    b-col
      b-form-group( label-for="input-correo-cambio" )
        template( #label ) Correos de cambios
        b-form-tags(
          id="input-correo-cambio"
          v-model="form.correo_cambio"
          placeholder="Agregar correos separados por espacio..."
          invalid-tag-text="Dirección de correo inválida: "
          separator=" "
          tag-variant="primary"
          :tag-validator="validateEmail"
          :disabled="disabled"
        )

  hr.form-empresa-separador

  b-row
    b-col
      Sucursales(
        ref="sucursales"
        v-if="idCliente && hasEmpresa"
        v-model="$v.form.sucursal.$model"
        :state="validateState('sucursal')"
        :clientIdOverride="idCliente"
        :disabled="disabled"
        @modal-closed="form.sucursal = null"
      )

  //- Dueño del equipo (SILL-1531). Sólo aplica a cliente empresa: este bloque
  //- vive dentro de FormEmpresa, así que nunca se renderiza para persona.
  //- Los datos se guardan en la OT, no en el cliente.
  b-row
    b-col( cols="12" )
      b-form-checkbox.dueno-equipo-toggle(
        id="checkbox-dueno-equipo"
        v-model="form.dueno_equipo_activo"
      )
        span( v-b-tooltip.hover.top="tooltipDuenoEquipo" ) Añadir datos del dueño del Equipo

  template( v-if="form.dueno_equipo_activo" )
    b-row.dueno-equipo-fields
      b-col( cols="12" md="6" )
        b-form-group( label-for="input-dueno-equipo-nombre" )
          template( #label ) Nombre
          b-form-input(
            id="input-dueno-equipo-nombre"
            v-model.trim="form.dueno_equipo_nombre"
            placeholder="Nombre del Cliente"
          )

      b-col( cols="12" md="6" )
        b-form-group( label-for="input-dueno-equipo-apellido" )
          template( #label ) Apellido
          b-form-input(
            id="input-dueno-equipo-apellido"
            v-model.trim="form.dueno_equipo_apellido"
            placeholder="Apellidos del Cliente"
          )

    b-row.dueno-equipo-fields
      b-col( cols="12" md="6" )
        b-form-group( label-for="input-dueno-equipo-correo" )
          template( #label ) Correo Electrónico
          b-form-input(
            id="input-dueno-equipo-correo"
            v-model.trim="$v.form.dueno_equipo_correo.$model"
            placeholder="Correo electrónico del Cliente"
            :state="validateOptionalState('dueno_equipo_correo')"
          )
          b-form-invalid-feedback Dirección de correo inválida

      b-col( cols="12" md="6" )
        b-form-group( label-for="input-dueno-equipo-telefono" )
          template( #label ) Teléfono
          b-form-input(
            id="input-dueno-equipo-telefono"
            v-model.trim="$v.form.dueno_equipo_telefono.$model"
            placeholder="Contacto del Cliente"
            maxLength="9"
            :state="validateOptionalState('dueno_equipo_telefono')"
          )
          b-form-invalid-feedback( v-if="!$v.form.dueno_equipo_telefono.numeric" )
            | Solo puedes ingresar numeros
          b-form-invalid-feedback( v-if="!$v.form.dueno_equipo_telefono.minLength" )
            | Debes ingresar 9 digitos
</template>

<script>
import {
  required,
  requiredIf,
  minValue,
  email,
  numeric,
  minLength,
} from 'vuelidate/lib/validators'
import validateEmail from '@/utils/validateEmail'
import Sucursales from './Sucursales.vue'

export default {
  components: { Sucursales },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: () => ({
        razon_social: null,
        correos_empresa: [],
        correo_cambio: [],
        sucursal: null,
        dueno_equipo_activo: false,
        dueno_equipo_nombre: null,
        dueno_equipo_apellido: null,
        dueno_equipo_correo: null,
        dueno_equipo_telefono: null,
      }),
    },
    idCliente: null,
    hasEmpresa: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {}
  },
  validations: {
    form: {
      razon_social: { required },
      correos_empresa: {
        required,
      },
      correo_cambio: {},
      sucursal: {
        required: requiredIf(function fn() {
          return this.idCliente && this.hasEmpresa
        }),
        notCreating: minValue(0),
      },
      // Dueño del equipo: los 3 campos son opcionales, sólo se valida el
      // formato cuando vienen con contenido (los validadores de vuelidate
      // pasan en vacío).
      dueno_equipo_correo: { email },
      dueno_equipo_telefono: { numeric, minLength: minLength(9) },
    },
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    // Validación removida, pasar este método al :state del b-form-tags para restaurar
    // correosTagState() {
    //   const { $dirty } = this.$v.form.correos_empresa;
    //   return $dirty ? (this.form.correos_empresa.length > 0) : null;
    // },
  },
  watch: {
    form: {
      handler(val, oldVal) {
        if (val.correos_empresa !== oldVal.correos_empresa) {
          this.$v.form.correos_empresa.$touch()
        }
      },
      deep: true,
    },
    // Al desmarcar el bloque se limpian los datos para que no viajen en el
    // payload de la OT (SILL-1531).
    'form.dueno_equipo_activo': function fn(activo) {
      if (activo) return
      this.form.dueno_equipo_nombre = null
      this.form.dueno_equipo_apellido = null
      this.form.dueno_equipo_correo = null
      this.form.dueno_equipo_telefono = null
      this.$v.form.dueno_equipo_correo.$reset()
      this.$v.form.dueno_equipo_telefono.$reset()
    },
  },
  methods: {
    validateEmail,
    validateState(name) {
      const { $dirty, $invalid } = this.$v.form[name]
      return $dirty ? !$invalid : null
    },
    // Campos opcionales: vacíos no se marcan ni como válidos ni como inválidos,
    // sólo se valida el formato cuando el usuario escribió algo (SILL-1531).
    validateOptionalState(name) {
      if (!this.form[name]) return null
      return this.validateState(name)
    },
    resetForm() {
      this.form = {}
      this.$nextTick(() => this.unTouch())
    },
    unTouch() {
      this.$v.form.$reset()
    },
    validate() {
      this.$v.form.$touch()
      return !this.$v.form.$invalid
    },
    openSucursalProvisory(datosProvisorios) {
      this.$refs.sucursales.openSucursalProvisory(datosProvisorios)
    },
  },
  created() {
    // Constante no reactiva: el tooltip se monta fuera del componente, así que
    // el color se aplica vía `customClass` con estilo global (SILL-1531).
    this.tooltipDuenoEquipo = {
      title: 'Incluir los datos del propietario del equipo en el registro',
      customClass: 'tooltip-dueno-equipo',
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.form-empresa::v-deep {
  .form-group label {
    font-family: 'Noto Sans', sans-serif;
    font-weight: 700;
    font-size: 15px;
    color: #23201c;
  }

  .form-control,
  .custom-select {
    border: 1px solid #525252;
    border-radius: 5px;

    &:focus {
      border-color: #fece2f;
      box-shadow: 0 0 0 2px rgba(254, 206, 47, 0.25);
    }
  }
}

/* Separa los datos de la empresa del grupo Sucursal + dueño del equipo */
.form-empresa-separador {
  border: 0;
  border-top: 1px solid #e0e0e0;
  margin: 8px 0 20px;
}

/* Dueño del equipo (SILL-1531) */
.dueno-equipo-toggle::v-deep {
  margin-bottom: 16px;

  .custom-control-label {
    font-family: 'Noto Sans', sans-serif;
    font-weight: 400;
    font-size: 15px;
    color: #23201c;
    padding-left: 6px;
    padding-top: 1px;
  }

  .custom-control-label::before {
    width: 18px;
    height: 18px;
    top: 2px;
    border: 2px solid #23201c;
    border-radius: 3px;
    background-color: #fff;
  }

  .custom-control-label::after {
    width: 18px;
    height: 18px;
    top: 2px;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #23201c;
    border-color: #23201c;
  }

  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 2px rgba(254, 206, 47, 0.25);
  }

  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: #23201c;
  }
}

.dueno-equipo-fields::v-deep {
  .form-control::placeholder {
    color: #8c8c8c;
  }
}

::v-deep .b-form-tags-button {
  padding: 0;
}

::v-deep #input-correos-empresa {
  @include media-breakpoint-down(sm) {
    padding: 10px 0 !important;

    &::placeholder {
      font-size: 13px;
      white-space: pre-line;
      position: relative;
      top: -10px;
    }
  }
}
</style>

<!-- El tooltip de BootstrapVue se monta en `body`, fuera del alcance del
     estilo scoped, por eso este bloque va sin `scoped` y acotado a la
     `customClass` del tooltip (SILL-1531). -->
<style lang="scss">
.tooltip.tooltip-dueno-equipo {
  .tooltip-inner {
    background-color: #000;
    color: #fff;
    font-family: 'Noto Sans', sans-serif;
    font-size: 13px;
  }

  &.bs-tooltip-top .arrow::before {
    border-top-color: #000;
  }

  &.bs-tooltip-bottom .arrow::before {
    border-bottom-color: #000;
  }

  &.bs-tooltip-left .arrow::before {
    border-left-color: #000;
  }

  &.bs-tooltip-right .arrow::before {
    border-right-color: #000;
  }
}
</style>
